import { render, staticRenderFns } from "./shopCheckPayment.vue?vue&type=template&id=054ae3b8"
import script from "./shopCheckPayment.vue?vue&type=script&lang=js"
export * from "./shopCheckPayment.vue?vue&type=script&lang=js"
import style0 from "./shopCheckPayment.vue?vue&type=style&index=0&id=054ae3b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports